<script setup lang="ts">
import CiModalFooter from '@/components/CiModal/CiModalFooter.vue';

/********************
 * PROPS & EMITS     *
 ********************/
export interface CiModalMailProps {
  buttons?: any;
  headline?: string;
  successMessage?: string | null;
}
const props = withDefaults(defineProps<CiModalMailProps>(), {
  headline: '',
  successMessage: null,
  buttons: () => [],
});

const emit = defineEmits<{
  close: [];
}>();

/********************
 * COMPOSITIONS      *
 ********************/
const { $gettext } = useGettext();

const message = computed(() => {
  return props.successMessage
    ? props.successMessage
    : $gettext('Thank you. Your operation has been completed successfully.');
});
</script>

<template>
  <div class="rounded bg-white shadow-2xl">
    <div class="p-4">
      <div class="container-fluid">
        <div class="row py-6">
          <div class="col-12">
            <div class="flex justify-center">
              <img
                src="~/assets/svg/icon-mail.svg"
                alt=""
                class="h-auto max-w-[200px]"
              />
            </div>
          </div>
        </div>
        <div class="row mt-6">
          <div class="col-12 text-center">
            <h5 v-if="props.headline">
              {{ props.headline }}
            </h5>
            <p>{{ message }}</p>
          </div>
        </div>
      </div>
    </div>
    <CiModalFooter
      v-if="props.buttons?.length"
      class="flex justify-center p-4"
    >
      <div
        v-for="(button, index) in props.buttons"
        :key="`${index}-${button.label}`"
      >
        <nuxt-link
          v-if="button.to"
          :class="button.classes.join(' ')"
          :to="button.to"
          class="button"
          @click="emit('close')"
        >
          {{ button.label }}
        </nuxt-link>
        <button
          v-if="button.onClick"
          :class="button.classes.join(' ')"
          class="button"
          type="button"
          @click="button.onClick"
        >
          {{ button.label }}
        </button>
      </div>
    </CiModalFooter>
  </div>
</template>

<style></style>
